import MessageFormValidate from "components/shared-components/MessageFormValidate";
import { APPROVE_RADIO_VALUE } from "constants/FormatDataContanst";
import { MODE_FORM } from "pages/DataFormatInvoice/utils";
import React from "react";
import Flatpickr from "react-flatpickr";
import { Controller } from "react-hook-form";
import NumberFormat from "react-number-format";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import {
  Button,
  ButtonGroup,
  Col,
  FormGroup,
  Label,
  Table,
  UncontrolledTooltip,
} from "reactstrap";
import { formatTaxCode } from "./utils";
export const formValidate = (errors, touched, field) => {
  if (field in errors) {
    return "is-invalid";
  } else {
    if (Object.keys(errors).length === 0 && Object.keys(touched).length === 0) {
      return "";
    } else if (field in touched) {
      // return "is-valid";
      return "";
    } else {
      return "";
    }
  }
};

export const formValidateObject = (errors, touched, fieldObject, field) => {
  //   console.log("errors", errors);
  //   console.log("touched", touched);
  //   console.log("field", field);
  if (errors[fieldObject] && errors[fieldObject][field]) {
    return "is-invalid";
  } else {
    if (Object.keys(errors).length === 0 && Object.keys(touched).length === 0) {
      return "";
    } else if (fieldObject in touched) {
      if (touched[fieldObject] && touched[fieldObject][field]) {
        // return "is-valid";
        return "";
      }
      return "";
    } else {
      return "";
    }
  }
};

export const formValidateFieldArray = (
  errors,
  touched,
  fieldArray,
  index,
  fieldChild,
  type
) => {
  if (
    errors[fieldArray] &&
    errors[fieldArray][index] &&
    errors[fieldArray][index][fieldChild]
  ) {
    if (type === "date" || type === "select") {
      return "flat-pick-is-invalid";
    } else {
      return "is-invalid";
    }
  } else {
    if (Object.keys(errors).length === 0 && Object.keys(touched).length === 0) {
      return "";
    } else if (fieldArray in touched) {
      if (
        touched[fieldArray][index] &&
        touched[fieldArray][index][fieldChild]
      ) {
        // return "is-valid";";
        return "";
      }
      return "";
    } else {
      return "";
    }
  }
};

// Reack hook form useFieldArray
export const generateInputFieldArray = (
  label,
  isRequire,
  inputType,
  errors,
  touched,
  fieldArray,
  index,
  fieldChild,
  placeholder,
  register,
  disabled,
  setInputValueChange,
  control,
  isThousandSeparator = false,
  allowNegative = false,
  isTaxCode = false
) => {
  const uniqueId = `${fieldArray}-${index}-${fieldChild}`;
  return (
    <React.Fragment>
      {/* <Label htmlFor={fieldChild}>
          {label}
          {isRequire && <span className="text-danger"> (*)</span>}
        </Label> */}
      {inputType === "textarea" ? (
        <textarea
          disabled={disabled}
          id={uniqueId}
          type={inputType}
          className={`form-control ${formValidateFieldArray(
            errors,
            touched,
            fieldArray,
            index,
            fieldChild
          )}`}
          placeholder={disabled ? "" : placeholder}
          {...register(`${fieldArray}.${index}.${fieldChild}`, {
            // onBlur: e => onBlurHandle(e, fieldArray, index, fieldChild),
          })}
        />
      ) : isThousandSeparator ? (
        <Controller
          control={control}
          name={`${fieldArray}.${index}.${fieldChild}`}
          render={({ field: { onChange, name, value } }) => (
            <NumberFormat
              thousandSeparator={true}
              disabled={disabled}
              id={uniqueId}
              //   isAllowed={values => {
              //     const { floatValue } = values;
              //     return floatValue >= 5 && floatValue <= 10000;
              //   }}
              allowNegative={allowNegative}
              className={`form-control ${formValidateFieldArray(
                errors,
                touched,
                fieldArray,
                index,
                fieldChild
              )}`}
              value={value}
              onValueChange={v => {
                onChange(Number(v.value));
                setInputValueChange &&
                  setInputValueChange({ fieldArray, index, fieldChild });
              }}
            />
          )}
        />
      ) : isTaxCode ? (
        <React.Fragment>
          <Controller
            control={control}
            name={`${fieldArray}.${index}.${fieldChild}`}
            render={({ field: { onChange, name, value } }) => (
              <NumberFormat
                // format="##########-###"
                style={{ width: "270px" }}
                id={uniqueId}
                allowEmptyFormatting={false}
                placeholder={disabled ? "" : "XXXXXXXXXX-XXX (Tối đa 14 kí tự)"}
                // mask="_"
                allowNegative={allowNegative}
                className={`form-control ${formValidateFieldArray(
                  errors,
                  touched,
                  fieldArray,
                  index,
                  fieldChild
                )}`}
                disabled={disabled}
                value={value}
                onValueChange={v => {
                  let finalValue = formatTaxCode(v.value);
                  onChange(finalValue);
                }}
              />
            )}
          />
        </React.Fragment>
      ) : (
        <input
          disabled={disabled}
          id={uniqueId}
          type={inputType}
          className={`form-control ${formValidateFieldArray(
            errors,
            touched,
            fieldArray,
            index,
            fieldChild
          )}`}
          //   placeholder={disabled ? "" : placeholder}
          {...register(`${fieldArray}.${index}.${fieldChild}`, {
            // onBlur: e => {
            //   onBlurHandle && onBlurHandle(e, fieldArray, index, fieldChild);
            // },
          })}
        />
      )}
      {errors[fieldArray] &&
        errors[fieldArray][index] &&
        errors[fieldArray][index][fieldChild] && (
          <UncontrolledTooltip
            // style={{
            //   color: "red",
            //   background: "white",
            //   border: "1px solid red",
            // }}
            placement="right"
            target={uniqueId}
          >
            {errors[fieldArray][index][fieldChild].message}
          </UncontrolledTooltip>
        )}
    </React.Fragment>
  );
};

export const generateSelectFieldArray = (
  label,
  isRequire,
  errors,
  touched,
  fieldArray,
  index,
  fieldChild,
  placeholder,
  disabled,
  control,
  options,
  onChangeHandle,
  menuPlacementSetting = "auto"
) => {
  const uniqueId = `${fieldArray}-${index}-${fieldChild}`;
  return (
    <React.Fragment>
      {/* <Label htmlFor={fieldChild}>  
          {label}
          {isRequire && <span className="text-danger"> (*)</span>}
        </Label> */}
      <div
        id={uniqueId}
        className={`${formValidateFieldArray(
          errors,
          touched,
          fieldArray,
          index,
          fieldChild,
          "select"
        )}`}
      >
        <Controller
          control={control}
          name={`${fieldArray}.${index}.${fieldChild}`}
          render={({ field }) => (
            // @ts-ignore
            <Select
              {...field}
              onChange={data => {
                field.onChange(data);
                onChangeHandle && onChangeHandle(fieldArray, index, fieldChild);
              }}
              isOptionSelected={(option, selectValue) =>
                selectValue.some(i => i === option)
              }
              menuPlacement={menuPlacementSetting}
              isDisabled={disabled}
              placeholder={disabled ? "" : placeholder}
              options={options}
              classNamePrefix="select2-selection"
            />
          )}
        />
      </div>

      {errors[fieldArray] &&
        errors[fieldArray][index] &&
        errors[fieldArray][index][fieldChild] && (
          <UncontrolledTooltip
            // style={{
            //   color: "red",
            //   background: "white",
            //   border: "1px solid red",
            // }}
            placement="right"
            target={uniqueId}
          >
            {errors[fieldArray][index][fieldChild].message}
          </UncontrolledTooltip>
        )}
    </React.Fragment>
  );
};

export const generateDateFieldArray = (
  labelFrom,
  labelTo,
  isRequire,
  errors,
  touched,
  fieldArray,
  index,
  fieldChild,
  placeholder,
  disabled,
  control,
  options
) => {
  const uniqueId = `${fieldArray}-${index}-${fieldChild}`;
  return (
    <React.Fragment>
      {/* <Label htmlFor={fieldChild}>
          {labelFrom}
          {labelFrom && isRequire && <span className="text-danger"> (*)</span>}
          {labelTo && `- ${labelTo}`}
          {labelTo && isRequire && <span className="text-danger"> (*)</span>}
        </Label> */}
      <div
        id={uniqueId}
        className={`${formValidateFieldArray(
          errors,
          touched,
          fieldArray,
          index,
          fieldChild,
          "date"
        )}`}
      >
        <Controller
          control={control}
          name={`${fieldArray}.${index}.${fieldChild}`}
          render={({ field }) => (
            <Flatpickr
              {...field}
              disabled={disabled}
              className={`form-control d-block Flatpickr__Input ${formValidateFieldArray(
                errors,
                touched,
                fieldArray,
                index,
                fieldChild
              )}`}
              placeholder={disabled ? "" : placeholder}
              options={options}
            />
          )}
        />
      </div>

      {errors[fieldArray] &&
        errors[fieldArray][index] &&
        errors[fieldArray][index][fieldChild] && (
          <UncontrolledTooltip
            // style={{
            //   color: "red",
            //   background: "white",
            //   border: "1px solid red",
            // }}
            placement="left"
            target={uniqueId}
          >
            {errors[fieldArray][index][fieldChild].message}
          </UncontrolledTooltip>
        )}
    </React.Fragment>
  );
};

// Reack hook form
export const generateRadioGroupApprove = (
  listField,
  setValue,
  nameGroup,
  watch,
  register,
  isDisable = false,
  isHide = false,
  eventExpand
) => {
  return listField.map(item => {
    const listAnother = listField.filter(f => f.field !== item.field);
    let currentValue = watch(item.field);
    if (currentValue === "true") {
      currentValue = true;
    } else if (currentValue === "false") {
      currentValue = false;
    }
    return (
      !isHide &&
      !item.isDisable && (
        <Col key={item.field}>
          <FormGroup className="mb-2">
            <Label
              style={{ cursor: "pointer" }}
              className="d-flex align-items-center gap-1"
            >
              <input
                {...register(item.field)}
                type="radio"
                name={nameGroup}
                disabled={isDisable || item.isDisable}
                checked={currentValue}
                value={currentValue}
                onClick={() => {
                  if (!currentValue) {
                    setValue(item.field, APPROVE_RADIO_VALUE.APPROVE);
                    for (const another of listAnother) {
                      setValue(another.field, APPROVE_RADIO_VALUE.NOT_APPROVE);
                    }
                  }
                  eventExpand && eventExpand(item.field, !currentValue);
                }}
                // id={item.field}
              ></input>
              {item.label}
            </Label>
          </FormGroup>
        </Col>
      )
    );
  });
};

export const generateCheckboxGroupApprove = (
  listField,
  register,
  isDisable = false,
  onClick,
  isHide = false
) => {
  return listField.map(item => {
    return (
      !isHide && (
        <Col key={item.field}>
          <FormGroup className="mb-2">
            <Label
              style={{ cursor: "pointer" }}
              className="d-flex align-items-center gap-1"
            >
              <input
                {...register(item.field)}
                type="checkbox"
                disabled={isDisable}
                onClick={e => {
                  onClick && onClick(e);
                }}
                name={item.field}
                id={item.field}
              ></input>
              {item.label}
            </Label>
          </FormGroup>
        </Col>
      )
    );
  });
};

// Reack hook form
export const generateInputPasswordField = (
  label,
  isRequire,
  inputType,
  errors,
  touched,
  fieldName,
  placeholder,
  register,
  disabled,
  isPassword,
  showPasswordHandle
) => {
  return (
    <React.Fragment>
      <Label htmlFor={fieldName}>
        {label}
        {isRequire && <span className="text-danger"> (*)</span>}
      </Label>

      <React.Fragment>
        <div className="d-flex">
          <input
            disabled={disabled}
            type={isPassword ? "password" : "text"}
            className={`form-control ${formValidate(
              errors,
              touched,
              fieldName
            )}`}
            placeholder={disabled ? "" : placeholder}
            {...register(`${fieldName}`)}
          />
          <button
            style={{
              borderBottomLeftRadius: 0,
              borderTopLeftRadius: 0,
              marginLeft: "-1px",
            }}
            type="button"
            onClick={() => {
              showPasswordHandle && showPasswordHandle();
            }}
            className="btn btn-outline-info"
          >
            <i className="fas fa-eye"></i>
          </button>
        </div>
      </React.Fragment>
      {errors[fieldName] && (
        <MessageFormValidate error={errors[fieldName].message} />
      )}
    </React.Fragment>
  );
};

export const generateInputField = (
  label,
  isRequire,
  inputType,
  errors,
  touched,
  fieldName,
  placeholder,
  register,
  disabled,
  widthLabel,
  control,
  isThousandSeparator = false,
  isTaxCode = false,
  allowNegative = false,
  onChangeHandle,
  buttonLoadTaxInfo,
  toUpperCase = false
) => {
  return (
    <React.Fragment>
      <Label htmlFor={fieldName} style={{ minWidth: widthLabel }}>
        {label}
        {isRequire && <span className="text-danger"> (*)</span>}
      </Label>
      {inputType === "textarea" ? (
        <textarea
          disabled={disabled}
          type={inputType}
          className={`form-control ${formValidate(errors, touched, fieldName)}`}
          placeholder={disabled ? "" : placeholder}
          {...register(`${fieldName}`)}
        />
      ) : isThousandSeparator ? (
        <Controller
          control={control}
          name={`${fieldName}`}
          render={({ field: { onChange, name, value } }) => (
            <NumberFormat
              thousandSeparator={true}
              className={`form-control ${formValidate(
                errors,
                touched,
                fieldName
              )}`}
              allowNegative={allowNegative}
              disabled={disabled}
              value={value}
              onValueChange={v => {
                onChange(v.value);
              }}
            />
          )}
        />
      ) : isTaxCode ? (
        <React.Fragment>
          <div className="d-flex align-items-center gap-1">
            {/* <Controller
              control={control}
              name={`${fieldName}`}
              render={({ field: { onChange, name, value } }) => (
                <NumberFormat
                  // format="##########-###"
                  style={{ width: "270px" }}
                  allowEmptyFormatting={false}
                  placeholder={disabled ? "" : placeholder}
                  // mask="_"
                  allowNegative={allowNegative}
                  className={`form-control ${formValidate(
                    errors,
                    touched,
                    fieldName
                  )}`}
                  disabled={disabled}
                  value={value}
                  onValueChange={v => {
                    let finalValue = formatTaxCode(v.value);
                    onChange(finalValue);
                    onChangeHandle && onChangeHandle(finalValue, fieldName);
                  }}
                />
              )}
            /> */}
            <input
              disabled={disabled}
              type={inputType}
              autoComplete="off"
              // style={styleInput}
              className={`form-control ${formValidate(
                errors,
                touched,
                fieldName
              )}`}
              placeholder={disabled ? "" : placeholder}
              {...register(`${fieldName}`)}
            />
            {buttonLoadTaxInfo && buttonLoadTaxInfo()}
          </div>
        </React.Fragment>
      ) : (
        <input
          disabled={disabled}
          type={inputType}
          className={`form-control ${formValidate(errors, touched, fieldName)}`}
          placeholder={disabled ? "" : placeholder}
          {...register(`${fieldName}`)}
          onInput={e => {
            if (toUpperCase) {
              e.target.value = ("" + e.target.value).toUpperCase();
            }
          }}
        />
      )}
      {errors[fieldName] && (
        <MessageFormValidate error={errors[fieldName].message} />
      )}
    </React.Fragment>
  );
};

export const generateSelectField = (
  label,
  isRequire,
  errors,
  field,
  placeholder,
  disabled,
  control,
  options,
  menuPlacementSetting = "auto",
  onChangeHandle,
  allowCreate = false,
  isLoading = false,
  isClearable = false,
  isMulti = false
) => {
  return (
    <React.Fragment>
      <Label htmlFor={field}>
        {label}
        {isRequire && <span className="text-danger"> (*)</span>}
      </Label>
      <Controller
        control={control}
        name={field}
        render={({ field }) =>
          !allowCreate ? ( // @ts-ignore
            <Select
              {...field}
              isMulti={isMulti}
              isLoading={isLoading}
              onChange={data => {
                field.onChange(data);
                onChangeHandle && onChangeHandle(data);
              }}
              isOptionSelected={
                isMulti
                  ? undefined
                  : (option, selectValue) => selectValue.some(i => i === option)
              }
              isClearable={isClearable}
              menuPlacement={menuPlacementSetting}
              isDisabled={disabled}
              placeholder={placeholder}
              options={options}
              classNamePrefix="select2-selection"
            />
          ) : (
            <CreatableSelect
              {...field}
              isClearable={isClearable}
              onChange={data => {
                field.onChange(data);
                onChangeHandle && onChangeHandle();
              }}
              isOptionSelected={(option, selectValue) =>
                selectValue.some(i => i === option)
              }
              menuPlacement={menuPlacementSetting}
              isDisabled={disabled}
              placeholder={disabled ? "" : placeholder}
              options={options}
              classNamePrefix="select2-selection"
            />
          )
        }
      />

      {errors[field] && <MessageFormValidate error={errors[field].message} />}
    </React.Fragment>
  );
};

export const generateDateField = (
  labelFrom,
  labelTo,
  isRequire,
  errors,
  field,
  placeholder,
  disabled,
  control,
  options
) => {
  return (
    <React.Fragment>
      <Label htmlFor={field}>
        {labelFrom}
        {labelFrom && isRequire && <span className="text-danger"> (*)</span>}
        {labelTo && `- ${labelTo}`}
        {labelTo && isRequire && <span className="text-danger"> (*)</span>}
      </Label>
      <Controller
        control={control}
        name={field}
        render={({ field }) => (
          <Flatpickr
            {...field}
            disabled={disabled}
            className="form-control d-block Flatpickr__Input"
            placeholder={placeholder}
            options={{
              ...options,
              allowInput: true,
            }}
          />
        )}
      />
      {errors[field] && <MessageFormValidate error={errors[field].message} />}
    </React.Fragment>
  );
};

// Reack hook form
/**
 * Ô chọn dạng 2 nút bấm cạnh nhau (vd "Bên bán" / "Bên mua").
 * Khác radio ở chỗ luôn có một lựa chọn nhìn thấy rõ đang được chọn.
 */
export const generateToggleField = ({
  label,
  isRequire,
  field,
  listData,
  setValue,
  watch,
  isDisable = false,
  widthLabel = null,
  errors = {},
}) => {
  const currentValue = watch(field);
  const errorMessage = errors?.[field]?.message;

  return (
    <>
      <div
        className="d-flex align-items-center mb-2"
        style={{ paddingTop: "8px" }}
      >
        <div style={{ fontWeight: "500", minWidth: widthLabel }}>
          {label}
          {isRequire && <span className="text-danger"> (*)</span>}:
        </div>
        {/* Nhóm nút liền nhau kiểu segmented, lựa chọn đang chọn tô primary */}
        <ButtonGroup size="sm">
          {(listData || []).map(item => {
            const isActive = String(currentValue) === String(item.value);

            return (
              <Button
                key={`${field}-${item.value}`}
                type="button"
                // Lựa chọn đang chọn tô primary, còn lại là nền xám nhạt để
                // cả nhóm nhìn như một dải liền, giống ô "Hình thức xử lý"
                color={isActive ? "primary" : "light"}
                active={isActive}
                disabled={isDisable}
                style={{ minWidth: "90px" }}
                // Đang báo lỗi thì kiểm tra lại ngay để chọn xong là mất lỗi
                onClick={() =>
                  setValue(field, item.value, {
                    shouldValidate: !!errorMessage,
                  })
                }
              >
                {item.label}
              </Button>
            );
          })}
        </ButtonGroup>
      </div>
      {errorMessage && (
        <div style={{ marginLeft: widthLabel }}>
          <MessageFormValidate error={errorMessage} />
        </div>
      )}
    </>
  );
};

export const generateRadioField = ({
  label,
  isRequire,
  field,
  listData,
  setValue,
  watch,
  register,
  isDisable = false,
  isHide = false,
  style = {},
  // Có widthLabel thì nhãn nằm CÙNG HÀNG với các lựa chọn, theo khuôn ô text
  // (generateInputField). Không truyền thì giữ bố cục cũ: nhãn trên, radio dưới.
  widthLabel = null,
  errors = {},
}) => {
  const currentValue = watch(field);
  if (isHide) return null;

  const isInline = !!widthLabel;
  const errorMessage = errors?.[field]?.message;
  const requireMark = isRequire && <span className="text-danger"> (*)</span>;

  return (
    <>
      <div
        // KHÔNG dùng class custom-form ở đây: nó định dạng lại input (gạch chân,
        // bỏ viền) nên vòng tròn radio bị mất
        className={isInline ? "d-flex align-items-center mb-2" : ""}
        style={isInline ? { paddingTop: "8px" } : undefined}
      >
        {isInline ? (
          <div style={{ fontWeight: "500", minWidth: widthLabel }}>
            {label}
            {requireMark}:
          </div>
        ) : (
          <Label htmlFor={field}>
            {label}
            {requireMark}
          </Label>
        )}
        <div
          className="d-flex align-items-center gap-3"
          style={isInline ? {} : { marginTop: "3px", ...style }}
        >
          {listData &&
            listData.map((item, index) => (
              <div
                key={`${field}-${index}`}
                className="form-check form-check-inline mb-0"
              >
                <input
                  className="form-check-input"
                  type="radio"
                  id={`${field}-${item.value}`}
                  {...register(field)}
                  value={item.value}
                  checked={Number(currentValue) === Number(item.value)}
                  // Đang báo lỗi thì kiểm tra lại ngay để chọn xong là mất lỗi
                  onChange={() =>
                    setValue(field, item.value, {
                      shouldValidate: !!errorMessage,
                    })
                  }
                  disabled={isDisable}
                />
                <label
                  className="form-check-label"
                  htmlFor={`${field}-${item.value}`}
                  style={{ cursor: "pointer" }}
                >
                  {item.label}
                </label>
              </div>
            ))}
        </div>
      </div>
      {errorMessage && (
        // Nhãn nằm cùng hàng thì thụt vào để lỗi thẳng cột với các lựa chọn
        <div style={isInline ? { marginLeft: widthLabel } : undefined}>
          <MessageFormValidate error={errorMessage} />
        </div>
      )}
    </>
  );
};

// Reack hook form object
export const generateInputFieldObject = (
  label,
  isRequire,
  inputType,
  errors,
  touched,
  fieldObject,
  field,
  placeholder,
  register,
  disabled,
  control,
  isTaxCode = false,
  isThousandSeparator = false,
  allowNegative = false
) => {
  return (
    <React.Fragment>
      <Label htmlFor={`${fieldObject}.${field}`}>
        {label}
        {isRequire && <span className="text-danger"> (*)</span>}
      </Label>
      {inputType === "textarea" ? (
        <textarea
          disabled={disabled}
          type={inputType}
          className={`form-control ${formValidateObject(
            errors,
            touched,
            fieldObject,
            field
          )}`}
          placeholder={placeholder}
          {...register(`${fieldObject}.${field}`)}
        />
      ) : isThousandSeparator ? (
        <Controller
          control={control}
          name={`${fieldObject}.${field}`}
          render={({ field: { onChange, name, value } }) => (
            <NumberFormat
              thousandSeparator={true}
              className={`form-control ${formValidateObject(
                errors,
                touched,
                fieldObject,
                field
              )}`}
              allowNegative={allowNegative}
              disabled={disabled}
              value={value}
              onValueChange={v => {
                onChange(v.value);
              }}
            />
          )}
        />
      ) : isTaxCode ? (
        <React.Fragment>
          <div className="d-flex align-items-center gap-1">
            <Controller
              control={control}
              name={`${fieldObject}.${field}`}
              render={({ field: { onChange, name, value } }) => (
                <NumberFormat
                  // format="##########-###"
                  style={{ width: "270px" }}
                  allowEmptyFormatting={allowNegative}
                  placeholder={disabled ? "" : placeholder}
                  // mask="_"
                  allowNegative={allowNegative}
                  className={`form-control ${formValidateObject(
                    errors,
                    touched,
                    fieldObject,
                    field
                  )}`}
                  disabled={disabled}
                  value={value}
                  onValueChange={v => {
                    let finalValue = formatTaxCode(v.value);
                    onChange(finalValue);
                  }}
                />
              )}
            />
          </div>
        </React.Fragment>
      ) : (
        <input
          disabled={disabled}
          type={inputType}
          className={`form-control ${formValidateObject(
            errors,
            touched,
            fieldObject,
            field
          )}`}
          placeholder={placeholder}
          {...register(`${fieldObject}.${field}`)}
        />
      )}
      {errors[fieldObject] && errors[fieldObject][field] && (
        <MessageFormValidate error={errors[fieldObject][field].message} />
      )}
    </React.Fragment>
  );
};

export const generateSelectFieldObject = (
  label,
  isRequire,
  errors,
  fieldObject,
  field,
  placeholder,
  disabled,
  control,
  options,
  menuPlacementSetting = "auto"
) => {
  return (
    <React.Fragment>
      <Label htmlFor={`${fieldObject}.${field}`}>
        {label}
        {isRequire && <span className="text-danger"> (*)</span>}
      </Label>
      <Controller
        control={control}
        name={`${fieldObject}.${field}`}
        render={({ field }) => (
          <Select
            {...field}
            menuPlacement={menuPlacementSetting}
            isDisabled={disabled}
            placeholder={placeholder}
            options={options}
            classNamePrefix="select2-selection"
          />
        )}
      />

      {errors[fieldObject] && errors[fieldObject][field] && (
        <MessageFormValidate error={errors[fieldObject][field].message} />
      )}
    </React.Fragment>
  );
};

export const generateDateFieldObject = (
  labelFrom,
  labelTo,
  isRequire,
  errors,
  fieldObject,
  field,
  placeholder,
  disabled,
  control,
  options
) => {
  return (
    <React.Fragment>
      <Label htmlFor={`${fieldObject}.${field}`}>
        {labelFrom}
        {labelFrom && isRequire && <span className="text-danger"> (*)</span>}
        {labelTo && `- ${labelTo}`}
        {labelTo && isRequire && <span className="text-danger"> (*)</span>}
      </Label>
      <Controller
        control={control}
        name={`${fieldObject}.${field}`}
        render={({ field }) => (
          <Flatpickr
            {...field}
            disabled={disabled}
            className="form-control d-block Flatpickr__Input"
            placeholder={placeholder}
            options={options}
          />
        )}
      />
      {errors[fieldObject] && errors[fieldObject][field] && (
        <MessageFormValidate error={errors[fieldObject][field].message} />
      )}
    </React.Fragment>
  );
};

export const OPTION_FIELD = {
  khmshdon: [
    {
      value: 1,
      label: "1- Hóa đơn điện tử giá trị gia tăng",
    },
    {
      value: 2,
      label: "2- Hóa đơn điện tử bán hàng",
    },

    {
      value: 3,
      label: "3- Hóa đơn điện tử bán tài sản công",
    },
    {
      value: 4,
      label: "4- Hóa đơn điện tử bán hàng dự trữ quốc gia",
    },
    {
      value: 5,
      label:
        "5- Hóa đơn điện tử khác là tem điện tử, vé điện tử, thẻ điện tử, phiếu thu điện tử hoặc các chứng từ điện tử có tên gọi khác nhưng có nội dung của hóa đơn điện tử theo quy định tại Nghị định 123/2020/NĐ-CP",
    },
    {
      value: 6,
      label:
        "6- Chứng từ điện tử được sử dụng và quản lý như hóa đơn gồm phiếu xuất kho kiêm vận chuyển nội bộ điện tử, phiếu xuất kho hàng gửi bán đại lý điện tử",
    },
    {
      value: 7,
      label: "7- Hóa đơn thương mại",
    },
    {
      value: 8,
      label:
        "8- Hóa đơn giá trị gia tăng tích hợp biên lai thu thuế, phí, lệ phí",
    },
    {
      value: 9,
      label: "9- Hóa đơn bán hàng tích hợp biên lai thu thuế, phí, lệ phí",
    },
  ],
  hthuc: [
    {
      value: 1,
      label: "Thêm mới",
    },
    {
      value: 2,
      label: "Gia hạn",
    },
    {
      value: 3,
      label: "Ngừng sử dụng",
    },
  ],
  ldkunhiem: [
    {
      value: 1,
      label: "Ủy nhiệm",
    },
    {
      value: 2,
      label: "Nhận ủy nhiệm",
    },
  ],
};

export const generateTableV2 = ({
  fieldConstant,
  listConstant,
  fieldsArray,
  removeFunc,
  addFunc,
  isAuto = false,
  styleTable = {},
  t,
  disableForm,
  touchedFields,
  register,
  errors,
  mode,
  optionDateLocale,
  control,
  isShowButton = true,
}) => {
  return (
    <div className="custom-table-border" style={{ ...styleTable }}>
      {!isAuto && mode !== MODE_FORM.VIEW && isShowButton && (
        <Button
          type="button"
          color={"primary"}
          size="sm"
          className="btn-label mb-2"
          onClick={addFunc}
        >
          <i className="fas fa-plus label-icon"></i>
          Thêm mới
        </Button>
      )}
      <Table className="table  table-bordered">
        <thead>
          <tr>
            <th className="text-center" style={{ width: "20px" }}>
              STT
            </th>
            {Object.entries(listConstant)
              .filter(([k, v]) => !v.isHide && k !== "field" && k !== "DNGAY")
              .map(([key, value]) => {
                let header = t(`field.${fieldConstant}.${value.field}`);
                if (key === "TNGAY") {
                  header = "Thời hạn";
                }
                return (
                  <th
                    style={{ width: value.width }}
                    className="text-center"
                    key={key}
                  >
                    {header}
                    {value.required && (
                      <span className="text-danger"> (*)</span>
                    )}
                  </th>
                );
              })}
            {!isAuto && <th style={{ width: "20px" }}></th>}
          </tr>
        </thead>
        <tbody>
          {fieldsArray.map((field, index) => {
            const fieldMain = fieldConstant;
            const listField = listConstant;
            const arrayField = [];
            for (const key in listField) {
              if (
                !listField[key].isHide &&
                key !== "field" &&
                key !== "DNGAY"
              ) {
                arrayField.push(key);
              }
            }
            const tdStyle = {
              display: "table-cell",
              verticalAlign: "bottom",
            };
            return (
              <tr key={index}>
                <td>{index + 1}</td>
                {arrayField.map(item => {
                  const itemField = listField[item];
                  let watchDisable = disableForm || itemField.isDisable;
                  switch (itemField.type) {
                    case "text":
                    case "number":
                      return (
                        <td style={tdStyle} key={item}>
                          {generateInputFieldArray(
                            t(`form.${itemField.field}`),
                            itemField.required,
                            itemField.type,
                            errors,
                            touchedFields,
                            fieldMain,
                            index,
                            itemField.field,
                            !watchDisable
                              ? t("placeholder.enter", {
                                  title: t(`form.${itemField.field}`),
                                })
                              : "",
                            register,
                            watchDisable,
                            null,
                            control,
                            false,
                            false,
                            itemField?.isTaxCode
                          )}
                        </td>
                      );
                    case "date":
                      return (
                        <td style={tdStyle} key={item}>
                          {generateDateFieldArray(
                            "Từ ngày",
                            "Đến ngày",
                            itemField.required,
                            errors,
                            touchedFields,
                            fieldConstant,
                            index,
                            itemField.field,
                            "DD/MM/YYYY hh - DD/MM/YYYY hh",
                            disableForm,
                            control,
                            {
                              ...optionDateLocale,
                              mode: "range",
                              enableTime: true,
                              dateFormat: "H:i",
                              time_24hr: true,
                            }
                          )}
                        </td>
                      );
                    case "select":
                      return (
                        <td style={tdStyle} key={item}>
                          {generateSelectFieldArray(
                            t(`form.${itemField.field}`),
                            itemField.required,
                            errors,
                            touchedFields,
                            fieldMain,
                            index,
                            itemField.field,
                            !itemField.disabled ? t("placeholder.select") : "",
                            watchDisable,
                            control,
                            OPTION_FIELD[itemField.field],
                            null,
                            "top"
                          )}
                        </td>
                      );
                    default:
                      break;
                  }
                })}
                {!isAuto && isShowButton && (
                  <td>
                    {mode !== MODE_FORM.VIEW && (
                      <React.Fragment>
                        <div className="action-icon text-center d-flex gap-2 align-items-center justify-content-center">
                          {fieldsArray.length > 1 && (
                            <i
                              onClick={() => {
                                removeFunc(index);
                              }}
                              className="mdi mdi-trash-can  text-danger font-size-18"
                              style={{ cursor: "pointer" }}
                            />
                          )}
                        </div>
                      </React.Fragment>
                    )}
                  </td>
                )}
              </tr>
            );
          })}
        </tbody>
      </Table>
    </div>
  );
};
